import styled from 'styled-components';

import {colors} from 'theme';

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const OptionCards = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
`;

export const OptionCard = styled.button<{$selected: boolean}>`
    flex: 1;
    min-width: 140px;
    min-height: 116px;
    position: relative;
    display: grid;
    place-content: center;
    gap: 10px;
    padding: 16px;
    border-radius: 10px;
    border: 1px solid ${({$selected}) => ($selected ? colors.brandPrimary : colors.border)};
    background: ${({$selected}) => ($selected ? colors.brandLight : colors.white)};
    cursor: pointer;
    color: ${({$selected}) => ($selected ? colors.brandPrimary : colors.textPrimary)};
    font-weight: 500;
    transition: border-color 0.2s ease, background-color 0.2s ease;

    &:hover {
        border-color: ${colors.brandPrimary};
        background: ${({$selected}) => ($selected ? colors.brandLight : colors.white)};
    }
`;

export const OptionLabel = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    & > div {
        padding: 10px;
        font-size: 16px;
        font-weight: 500;
        color: ${colors.brandPrimary};
        background: ${colors.brandLight};
        border-radius: 6px;
    }

    & > span {
        font-size: 14px;
    }
`;

export const OptionCheck = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.brandPrimary};
    border-radius: 50%;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 12px;
    right: 12px;
`;

export const StartButtonWrap = styled.div`
    display: flex;
    justify-content: flex-end;

    & > * {
        width: fit-content;
    }
`;
